import React, { Component } from 'react';
import logo from '../../../../images/LOGO_PATHE.png';
import facebooklogin from '../../../../images/FACEBOOK.png';
import Config from "../../../../config/config";

// import popcorn from '../../../../images/POPCORN_BAG.png';

export default class SocialLogin extends Component {

	componentDidMount() {
		window.gtag('config', Config.googleAnalyticsCode, {
			'page_title' : 'Login-Social',
			'page_path': '/login/social'
		});
	}

	render() {
			return(
				<div className="container">
					<div className="logo" ><img src={logo} width="100%" alt="logo" /></div>
					<div className="sociallogin">
						REGISTREER VOOR<br/><b>VETTE PRIJZEN!</b>
						<br/><br/>
						<img src={facebooklogin} onClick={this.props.loginCallback} width="100%" alt="Facebook" />
					</div>
					{/* <div className="popcorn"><img style={{width:"100%"}} src={popcorn} alt="popcorn" /></div>
					<div className="curtains" ></div> */}
				</div>
			);
	}
}


// WEBPACK FOOTER //
// ./src/components/pages/Login/SocialLogin/SocialLogin.js